import { Component, Input } from '@angular/core';
import { getEquipmentlogStatusTextFunction } from '../../functions/get-equipmentlog-status-text.function';
import { WorkEquipmentlog } from '../../_generated/work-rest-api';

@Component({
  selector: 'ax-office-betriebsmittel-aktueller-status',
  templateUrl: './betriebsmittel-aktueller-status.component.html',
  styleUrls: ['./betriebsmittel-aktueller-status.component.scss'],
})
export class BetriebsmittelAktuellerStatusComponent {
  @Input() equipmentlog: WorkEquipmentlog | undefined;
  @Input() renderTextOnly = false;
  public hasReadPermission = true;
  protected readonly getEquipmentlogStatusTextFunction = getEquipmentlogStatusTextFunction;

  public get colorForBadge() {
    if (this.equipmentlog) {
      switch (this.equipmentlog.equipmentlogtypeId) {
        case 1:
        case 2:
          return 'primary';
        case 3:
        case 4:
          return 'danger';
      }
    }
    return 'primary';
  }
}
